import React from "react";
import PropTypes from "prop-types";
import PostTile from "./PostTile";
import BellIcon from "../../assets/svg/components/bell.inline.svg";

const RelatedPosts = ({ relatedPosts }) => {
  return (
    <section className={"related-posts"}>
      <div className="h3 with-icon">
        <BellIcon/>
        <span>อัพเดท บทความ ข่าวสารจาก GClub</span>
      </div>
      <ul className={"related-list post-list"}>
        {relatedPosts.map((item, index) =>
        {
          return <PostTile index={index} post={item.node} key={"post-tile-" + index}/>
        })
        }
      </ul>
    </section>
  );
};

export default RelatedPosts;

RelatedPosts.propTypes = {
  relatedPosts: PropTypes.array,
};
